/* ANIS BROWS v2 — interaction engine (vanilla, dependency-free) */
(function () {
  "use strict";
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  /* ---------- Preloader ---------- */
  document.body.classList.add("loading");
  const pre = $(".preloader");
  const hidePre = () => {
    pre && pre.classList.add("done");
    document.body.classList.remove("loading");
  };
  window.addEventListener("load", () => setTimeout(hidePre, 1500));
  setTimeout(hidePre, 3000); // safety

  /* ---------- Scroll progress ---------- */
  const bar = $(".progress");
  const setProgress = () => {
    if (!bar) return;
    const h = document.documentElement;
    const p = h.scrollTop / (h.scrollHeight - h.clientHeight || 1);
    bar.style.width = p * 100 + "%";
  };

  /* ---------- Header shadow ---------- */
  const header = $(".header");
  const onScroll = () => {
    header && header.classList.toggle("scrolled", window.scrollY > 10);
    setProgress();
  };
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  /* ---------- Custom cursor + magnetic ---------- */
  if (!reduce && window.matchMedia("(hover:hover)").matches) {
    const dot = document.createElement("div");
    dot.className = "cursor-dot";
    const ring = document.createElement("div");
    ring.className = "cursor-ring";
    document.body.append(dot, ring);
    let mx = 0, my = 0, rx = 0, ry = 0;
    window.addEventListener("mousemove", (e) => {
      mx = e.clientX; my = e.clientY;
      dot.style.transform = `translate(${mx}px,${my}px) translate(-50%,-50%)`;
    });
    const loop = () => {
      rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18;
      ring.style.transform = `translate(${rx}px,${ry}px) translate(-50%,-50%)`;
      requestAnimationFrame(loop);
    };
    loop();
    $$("a,button,.magnetic,.variant,.faq-q,.acc-q").forEach((el) => {
      el.addEventListener("mouseenter", () => ring.classList.add("hover"));
      el.addEventListener("mouseleave", () => ring.classList.remove("hover"));
    });
    // magnetic buttons
    $$(".magnetic").forEach((el) => {
      el.addEventListener("mousemove", (e) => {
        const r = el.getBoundingClientRect();
        const x = e.clientX - r.left - r.width / 2;
        const y = e.clientY - r.top - r.height / 2;
        el.style.transform = `translate(${x * 0.25}px,${y * 0.35}px)`;
      });
      el.addEventListener("mouseleave", () => (el.style.transform = ""));
    });
  }

  /* ---------- Reveal (incl. mask) ---------- */
  const io = new IntersectionObserver(
    (entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } }),
    { threshold: 0.12 }
  );
  $$(".reveal,.mask-reveal").forEach((el) => io.observe(el));
  // auto-stagger grid children
  $$(".bento,.ing-grid,.scrolly-steps,.why-grid,.apgrid,.pgrid,.al-gwrap").forEach((g) =>
    [...g.children].forEach((c, i) => c.classList.contains("reveal") && c.setAttribute("data-d", Math.min(i + 1, 5)))
  );

  /* ---------- Animated counters ---------- */
  const animateCount = (el) => {
    const target = parseFloat(el.dataset.count);
    const dec = (el.dataset.dec | 0);
    const suffix = el.dataset.suffix || "";
    const prefix = el.dataset.prefix || "";
    let start = 0; const dur = 1600; const t0 = performance.now();
    const step = (t) => {
      const p = Math.min((t - t0) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      const val = (target * eased).toFixed(dec);
      el.textContent = prefix + (dec ? val : Math.round(val).toLocaleString()) + suffix;
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  const cio = new IntersectionObserver((entries) => entries.forEach((e) => {
    if (e.isIntersecting) { animateCount(e.target); cio.unobserve(e.target); }
  }), { threshold: 0.6 });
  $$("[data-count]").forEach((el) => cio.observe(el));

  /* ---------- 3D tilt media ---------- */
  if (!reduce) $$(".media-tilt").forEach((wrap) => {
    const card = $(".card", wrap);
    wrap.addEventListener("mousemove", (e) => {
      const r = wrap.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      card.style.transform = `rotateY(${x * 9}deg) rotateX(${-y * 9}deg) translateZ(10px)`;
    });
    wrap.addEventListener("mouseleave", () => (card.style.transform = ""));
  });

  /* ---------- Scrollytelling ritual ---------- */
  const steps = $$(".s-step");
  const slides = $$(".scrolly-media img");
  if (steps.length && slides.length) {
    const sio = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          const i = +e.target.dataset.step;
          steps.forEach((s) => s.classList.toggle("active", +s.dataset.step === i));
          slides.forEach((s) => s.classList.toggle("active", +s.dataset.step === i));
        }
      });
    }, { threshold: 0.6, rootMargin: "-20% 0px -20% 0px" });
    steps.forEach((s) => sio.observe(s));
  }

  /* ---------- Hero parallax ---------- */
  const heroLayer = $(".hero-layer");
  if (heroLayer && !reduce) {
    let tick = false;
    window.addEventListener("scroll", () => {
      if (tick) return; tick = true;
      requestAnimationFrame(() => {
        heroLayer.style.transform = `translateY(${Math.min(window.scrollY, 900) * 0.22}px)`;
        tick = false;
      });
    }, { passive: true });
  }

  /* ---------- Subtle parallax depth on banner image (premium) ---------- */
  if (!reduce) {
    const ebBg = $(".eb-bg");
    if (ebBg) {
      const banner = ebBg.closest(".eb-banner") || ebBg.parentElement;
      let pt = false;
      const par = () => {
        const r = banner.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) {
          const prog = (window.innerHeight - r.top) / (window.innerHeight + r.height);
          ebBg.style.transform = `scale(1.14) translateY(${(prog - 0.5) * 60}px)`;
        }
        pt = false;
      };
      window.addEventListener("scroll", () => { if (!pt) { pt = true; requestAnimationFrame(par); } }, { passive: true });
      par();
    }
  }

  /* ---------- Before / After slider ---------- */
  const ba = $(".ba-wrap");
  if (ba) {
    const after = $(".ba-after", ba);
    const handle = $(".ba-handle", ba);
    let dragging = false;
    const move = (clientX) => {
      const r = ba.getBoundingClientRect();
      let p = ((clientX - r.left) / r.width) * 100;
      p = Math.max(2, Math.min(98, p));
      after.style.clipPath = `inset(0 0 0 ${p}%)`;
      handle.style.left = p + "%";
    };
    const down = () => (dragging = true);
    const up = () => (dragging = false);
    handle.addEventListener("mousedown", down);
    window.addEventListener("mouseup", up);
    window.addEventListener("mousemove", (e) => dragging && move(e.clientX));
    handle.addEventListener("touchstart", down, { passive: true });
    window.addEventListener("touchend", up);
    window.addEventListener("touchmove", (e) => dragging && move(e.touches[0].clientX), { passive: true });
    ba.addEventListener("click", (e) => move(e.clientX));
  }

  /* ---------- Gallery ---------- */
  const mainImg = $("#galleryMain img");
  /* hover-zoom magnifier on the main product image (desktop) */
  const gMain = $("#galleryMain");
  if (gMain && mainImg && !reduce && window.matchMedia("(hover:hover)").matches) {
    gMain.addEventListener("mousemove", (e) => {
      const r = gMain.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width) * 100;
      const y = ((e.clientY - r.top) / r.height) * 100;
      mainImg.style.transition = "transform .08s linear";
      mainImg.style.transformOrigin = x + "% " + y + "%";
      mainImg.style.transform = "scale(2)";
    });
    gMain.addEventListener("mouseleave", () => {
      mainImg.style.transition = "transform .5s var(--ease)";
      mainImg.style.transform = "";
    });
  }
  $$(".gallery-thumbs button").forEach((btn) =>
    btn.addEventListener("click", () => {
      $$(".gallery-thumbs button").forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
      if (mainImg) { mainImg.style.opacity = 0; setTimeout(() => { mainImg.src = btn.dataset.full; mainImg.style.opacity = 1; }, 160); }
    })
  );

  /* ---------- Variants -> Shopify cart form ---------- */
  const variants = $$("#variants .variant");
  const variantId = $("#variantId");
  const addBtnLabel = document.querySelector('.anis-form button[name="add"] span');
  const sPr = $(".sticky-cta .pr");
  variants.forEach((v) => v.addEventListener("click", () => {
    variants.forEach((x) => x.classList.remove("active"));
    v.classList.add("active");
    if (variantId && v.dataset.vid) variantId.value = v.dataset.vid;
    const price = v.querySelector(".v-price b") ? v.querySelector(".v-price b").textContent.trim() : ("$" + (v.dataset.price||""));
    if (addBtnLabel) addBtnLabel.textContent = "Add to Bag · " + price;
    if (sPr) sPr.textContent = price;
  }));

  /* ---------- Quantity ---------- */
  $$(".qty").forEach((q) => {
    const input = $("input", q);
    $$("button", q).forEach((b) => b.addEventListener("click", () => {
      let v = parseInt(input.value, 10) || 1;
      input.value = b.dataset.step === "up" ? v + 1 : Math.max(1, v - 1);
    }));
  });

  /* ---------- Mini-cart drawer (AJAX, real Shopify cart) ---------- */
  const drawer = $("#cartDrawer");
  if (drawer) {
    const itemsEl = $("#cdItems"), subEl = $("#cdSubtotal"), countEl = $(".cart-count");
    const money = (c) => "$" + (c / 100).toFixed(2);
    const openCart = () => { drawer.classList.add("open"); document.body.style.overflow = "hidden"; };
    const closeCart = () => { drawer.classList.remove("open"); document.body.style.overflow = ""; };
    $$("[data-cd-close]").forEach((el) => el.addEventListener("click", closeCart));
    document.addEventListener("keydown", (e) => e.key === "Escape" && closeCart());
    const setCount = (n) => { if (countEl) countEl.textContent = n; };
    const getCart = () => fetch("/cart.js", { headers: { Accept: "application/json" } }).then((r) => r.json());
    const changeQty = (key, qty) => fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) }).then((r) => r.json());
    function render(cart) {
      setCount(cart.item_count);
      if (!cart.items || !cart.items.length) {
        itemsEl.innerHTML = '<div class="cd-empty">Your bag is empty.</div>';
        subEl.textContent = money(0); return;
      }
      itemsEl.innerHTML = cart.items.map((it) =>
        `<div class="cd-item" data-key="${it.key}"><img src="${it.image || ""}" alt="">` +
        `<div class="cd-meta"><b>${it.product_title}</b><span class="cd-price">${money(it.final_line_price)}</span>` +
        `<div class="cd-qty"><button data-dec aria-label="Decrease">−</button><span>${it.quantity}</span><button data-inc aria-label="Increase">+</button></div>` +
        `<button class="cd-remove" data-rm>Remove</button></div></div>`).join("");
      subEl.textContent = money(cart.total_price);
      $$(".cd-item", itemsEl).forEach((row) => {
        const key = row.dataset.key, qty = parseInt($(".cd-qty span", row).textContent, 10);
        $("[data-inc]", row).addEventListener("click", () => changeQty(key, qty + 1).then(render));
        $("[data-dec]", row).addEventListener("click", () => changeQty(key, qty - 1).then(render));
        $("[data-rm]", row).addEventListener("click", () => changeQty(key, 0).then(render));
      });
    }
    const cartBtn = $(".cart-btn");
    if (cartBtn) cartBtn.addEventListener("click", (e) => { e.preventDefault(); getCart().then((c) => { render(c); openCart(); }); });
    // intercept the product add-to-cart form → AJAX add → open drawer
    const pform = document.querySelector('form[action^="/cart/add"], form.anis-form');
    if (pform) pform.addEventListener("submit", (e) => {
      e.preventDefault();
      const lbl = pform.querySelector('[name="add"] span'), old = lbl && lbl.textContent;
      if (lbl) lbl.textContent = "Adding…";
      fetch("/cart/add.js", { method: "POST", body: new FormData(pform), headers: { Accept: "application/json" } })
        .then((r) => r.json()).then(() => getCart()).then((c) => { render(c); openCart(); if (lbl) lbl.textContent = old; })
        .catch(() => { if (lbl) lbl.textContent = old; pform.submit(); });
    });
    getCart().then((c) => setCount(c.item_count));
  }

  /* ---------- FAQ + accordion ---------- */
  $$(".faq-item").forEach((item) => {
    const a = $(".faq-a", item);
    $(".faq-q", item).addEventListener("click", () => {
      const open = item.classList.contains("open");
      $$(".faq-item").forEach((i) => { i.classList.remove("open"); $(".faq-a", i).style.maxHeight = null; });
      if (!open) { item.classList.add("open"); a.style.maxHeight = a.scrollHeight + "px"; }
    });
  });
  $$(".acc-item").forEach((item) => {
    const a = $(".acc-a", item);
    if (item.classList.contains("open")) a.style.maxHeight = a.scrollHeight + "px";
    $(".acc-q", item).addEventListener("click", () => {
      const open = item.classList.contains("open");
      item.classList.toggle("open", !open);
      a.style.maxHeight = open ? null : a.scrollHeight + "px";
    });
  });

  /* ---------- Sticky CTA ---------- */
  const sticky = $(".sticky-cta"); const anchor = $("[data-sticky-anchor]");
  if (sticky && anchor) {
    const aio = new IntersectionObserver((es) => es.forEach((e) =>
      sticky.classList.toggle("show", !e.isIntersecting && e.boundingClientRect.top < 0)
    ), { threshold: 0 });
    aio.observe(anchor);
  }

  /* ---------- Mobile menu ---------- */
  const menu = $(".mobile-menu");
  $(".burger") && $(".burger").addEventListener("click", () => menu.classList.add("open"));
  $(".mobile-menu .close") && $(".mobile-menu .close").addEventListener("click", () => menu.classList.remove("open"));
  menu && $$("a", menu).forEach((a) => a.addEventListener("click", () => menu.classList.remove("open")));

  /* ---------- Newsletter ---------- */
  $$(".news form").forEach((f) => f.addEventListener("submit", (e) => {
    e.preventDefault();
    f.innerHTML = '<p style="color:var(--gold-soft);font-size:1.1rem;font-family:var(--ff-d)">Welcome to the ritual. Your code is on its way ✦</p>';
  }));

  /* ---------- Smooth anchor scroll ---------- */
  $$('a[href^="#"]').forEach((a) => a.addEventListener("click", (e) => {
    const id = a.getAttribute("href");
    if (id.length > 1) { const t = $(id); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: reduce ? "auto" : "smooth" }); } }
  }));
})();
